(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ehw-autumn-upgrade-2026"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const filters = root.querySelector('.ehw26__filters');
    if (filters) filters.hidden = false;
    root.addEventListener('click', (event) => {
      const filter = event.target.closest('[data-filter]');
      if (filter && root.contains(filter)) {
        root.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
        let count = 0;
        root.querySelectorAll('.ehw26__lineup-grid [data-purpose]').forEach(card => {
          card.hidden = filter.dataset.filter !== 'all' && card.dataset.purpose !== filter.dataset.filter;
          if (!card.hidden) count++;
        });
        root.querySelector('[data-filter-status]').textContent = `${count}件の商品を表示しています`;
      }
      const link = event.target.closest('[data-ehw26-cta]');
      if (!link || !root.contains(link)) return;
      const detail = {campaign:'autumn_upgrade_2026', action:link.dataset.ehw26Cta, model:link.dataset.model || '', product_id:link.dataset.product || '', variant_id:link.dataset.variant || '', state:root.dataset.state};
      root.dispatchEvent(new CustomEvent('ehw26:cta', {bubbles:true, detail}));
      if (root.dataset.clicks !== 'true') return;
      const shopify = window.Shopify;
      if (shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
      try { shopify?.analytics?.publish?.('ehw_autumn_lp_cta', detail); } catch (_) {}
    });
    const end = Date.parse(root.dataset.end);
    let expired = root.dataset.state === 'ended';
    function checkExpiry(force = false) {
      if (root.dataset.editorPreview === 'true' || expired) return;
      const now = Date.now();
      const active = ['live', 'tm_ended'].includes(root.dataset.state);
      const closingSoon = !force && active && Number.isFinite(end) && now >= end - 86400000 && now < end;
      if (root.dataset.closingSoon !== String(closingSoon)) {
        root.dataset.closingSoon = String(closingSoon);
        if (active) root.querySelector('.ehw26__status').textContent = closingSoon ? 'セール終了間近' : '秋のアップグレードSALE';
      }
      if (!force && (!Number.isFinite(end) || now < end)) return;
      expired = true;
      root.dataset.state = 'ended';
      root.querySelectorAll('.ehw26__hero-image,.ehw26__discount,.ehw26__gold,.ehw26__stock,.ehw26__fine,.ehw26__notice,.ehw26__offer-note').forEach(el => el.hidden = true);
      root.querySelector('.ehw26__hero-copy')?.classList.remove('ehw26__sr-only');
      root.querySelector('.ehw26__status').textContent = 'セールは終了しました';
      const intro = root.querySelector('.ehw26__actionbar > div');
      intro.textContent = '秋のアップグレードSALEは終了しました。現在の価格・条件は商品ページをご確認ください。';
      root.querySelectorAll('.ehw26__price-table tbody td').forEach(el => el.textContent = '—');
      root.querySelectorAll('.ehw26__price-table thead th')[2].textContent = '商品ページで確認';
      root.querySelectorAll('.ehw26__price-table thead th')[3].textContent = '';
      root.querySelectorAll('.ehw26__price').forEach(el => el.textContent = '現在の価格は商品ページでご確認ください');
      root.querySelectorAll('[data-ehw26-cta="hero"],[data-ehw26-cta="footer"]').forEach(el => el.textContent = '現在の商品を見る');
      root.querySelectorAll('.ehw26__faq details p').forEach(el => el.textContent = '今回のセールは終了しました。現在の購入条件は各商品ページ、保証・返品・配送については上記の公式案内をご確認ください。');
    }
    let currentRequest = null;
    let lastRefresh = 0;
    async function refreshOffer() {
      checkExpiry();
      if (!root.isConnected || expired || root.dataset.editorPreview === 'true' || document.hidden || currentRequest || !root.dataset.sectionId || !['live', 'tm_ended'].includes(root.dataset.state) || Date.now() - lastRefresh < 5000) return;
      lastRefresh = Date.now();
      const controller = new AbortController();
      currentRequest = controller;
      const timeout = window.setTimeout(() => controller.abort(), 10000);
      try {
        const url = new URL(window.location.href);
        url.hash = '';
        url.searchParams.delete('section_id');
        url.searchParams.set('sections', root.dataset.sectionId);
        const response = await fetch(url, {credentials:'same-origin', cache:'no-store', signal:controller.signal});
        if (!response.ok) return;
        const sections = await response.json();
        const html = sections[root.dataset.sectionId];
        if (typeof html !== 'string') return;
        const next = new DOMParser().parseFromString(html, 'text/html').getElementById(root.id);
        checkExpiry();
        if (!root.isConnected || expired || !next || next.dataset.sectionId !== root.dataset.sectionId || next.dataset.end !== root.dataset.end) return;
        if (next.dataset.state === 'ended') { checkExpiry(true); return; }
        if (!['live', 'tm_ended'].includes(next.dataset.state)) return;
        const updates = [...root.querySelectorAll('[data-ehw26-refresh]')].map(current => {
          const replacement = next.querySelector(`[data-ehw26-refresh="${current.dataset.ehw26Refresh}"]`);
          return {current, replacement};
        });
        if (updates.some(({replacement}) => !replacement)) return;
        const focused = document.activeElement;
        const restoreFocus = updates.some(({current, replacement}) => current.outerHTML !== replacement.outerHTML && current.contains(focused));
        const focusedHref = focused?.getAttribute('href');
        const focusedAction = focused?.dataset.ehw26Cta;
        updates.forEach(({current, replacement}) => {
          if (current.outerHTML !== replacement.outerHTML) current.replaceWith(replacement);
        });
        root.dataset.state = next.dataset.state;
        if (restoreFocus) {
          const matchingLink = [...root.querySelectorAll('[data-ehw26-cta]')].find(link => link.getAttribute('href') === focusedHref && link.dataset.ehw26Cta === focusedAction);
          const focusTarget = matchingLink || root.querySelector('[data-ehw26-cta="product"][data-model="TM-160PW"]');
          focusTarget?.focus({preventScroll:true});
        }
      } catch (_) {
      } finally {
        window.clearTimeout(timeout);
        currentRequest = null;
      }
    }
    function resume() {
      checkExpiry();
      if (!document.hidden) refreshOffer();
    }
    function dispose() {
      window.clearInterval(timer);
      window.clearInterval(refreshTimer);
      document.removeEventListener('visibilitychange', resume);
      window.removeEventListener('focus', resume);
      currentRequest?.abort();
    }
    checkExpiry();
    const timer = window.setInterval(() => {
      if (!root.isConnected) { dispose(); return; }
      checkExpiry();
    }, 1000);
    const refreshTimer = window.setInterval(refreshOffer, 30000);
    document.addEventListener('visibilitychange', resume);
    window.addEventListener('focus', resume);
  }
  function scan() { document.querySelectorAll('.ehw26').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once:true}); else scan();
  document.addEventListener('shopify:section:load', scan);
})();


  } catch(e) { console.error(e); }
})();
})();
